import { Redirect, Route, Switch } from 'react-router-dom'
import { ClientList } from '../containers/ClientList'
import { ClientDetail } from '../containers/ClientDetail'
import { ClientDetailCashflow } from '../containers/ClientDetailCashflow'
import { ClientDetailDeals } from '../containers/ClientDetailDeals'
import { InvestmentQuestionnaire } from '../containers/InvestmentQuestionnaire'
import { ImportDocuments } from '../containers/ImportDocuments'
import { OrderList } from '../containers/OrderList'
import { useKeycloak } from '@react-keycloak/web'
import { PrivateRoute } from './routes/PrivateRoute'
import LoginPage from '../containers/LoginPage'
import { ClientOrderList } from '../containers/ClientOrderList'
import { InstrumentList } from '../containers/InstrumentList'
import { AccessForbidden } from '../containers/AccessForbidden'
import { getClientIdFromUser, isClientUser } from '../services/keycloak.service'
import { ClientDetailTaxPosition } from '../containers/ClientDetailTaxPosition'
import { ClientDetailTaxSummary } from '../containers/ClientDetailTaxSummary'
import { TraderDiary } from '../containers/TraderDiary'
import { Documents } from '../containers/Documents'
import { ClientDetailDocuments } from '../containers/ClientDetailDocuments'
import { MarketOverview } from '../containers/MarketOverview'
import { OpsRoot } from '../modules/ops/integration/OpsRoot'
import { DistributorMgmtFee } from '../modules/ops/integration/DistributorMgmtFee'

export enum Pages {
  Home = '/',
  Login = '/login',
  ClientDetail = '/client-detail',
  ClientDetailDeal = '/client-detail-deal',
  ClientDetailCashflow = '/client-detail-cashflow',
  ClientDetailTaxSummary = '/client-detail-tax-summary',
  ClientDetailTaxPossition = '/client-detail-tax-possition',
  OrderList = '/order-list',
  ClientOrderList = '/client-order-list',
  ClientInstrumentOrderList = '/client-instrument-order-list',
  InstrumentList = '/instrument-list',
  AccessForbidden = '/access-forbidden',
  InvestmentQuestionnaire = '/investment-questionnaire',
  ImportDocuments = '/import-documents',
  TraderDiary = '/trader-diary',
  Documents = '/documents',
  ClientDetailDocuments = '/client-detail-documents',
  MarketOverview = '/market-overview',
  Ops = '/fond',
  DistributorMgmtFee = '/management-fee'
}

const redirectToClientIQ = () => {
  const clientId = getClientIdFromUser()
  return <Redirect to={Pages.InvestmentQuestionnaire + '/' + clientId} />
}

export const AppRouter = () => {
  const { initialized } = useKeycloak()

  if (!initialized) {
    return <div>Loading...</div>
  }

  return (
    <Switch>
      {!isClientUser() && (
        <>
          <PrivateRoute
            path={Pages.ClientDetail + '/:clientId/:portfolio'}
            protectedRoute={false}
            distributorAllowed={true}
            component={ClientDetail}
            exact={true}
          />
          <PrivateRoute
            path={Pages.ClientDetail + '/:clientId/'}
            protectedRoute={false}
            distributorAllowed={true}
            component={ClientDetail}
            exact={true}
          />
          <PrivateRoute
            path={Pages.ClientDetailDeal + '/:clientId/'}
            protectedRoute={false}
            distributorAllowed={true}
            component={ClientDetailDeals}
            exact={true}
          />
          <PrivateRoute
            path={Pages.ClientDetailCashflow + '/:clientId/'}
            protectedRoute={false}
            distributorAllowed={true}
            component={ClientDetailCashflow}
            exact={true}
          />
          <PrivateRoute
            path={Pages.ClientDetailTaxPossition + '/:clientId/'}
            protectedRoute={false}
            distributorAllowed={true}
            component={ClientDetailTaxPosition}
            exact={true}
          />
          <PrivateRoute
            path={Pages.ClientDetailTaxSummary + '/:clientId/'}
            protectedRoute={false}
            distributorAllowed={true}
            component={ClientDetailTaxSummary}
            exact={true}
          />
          <PrivateRoute
            path={Pages.ClientOrderList + '/:clientId'}
            protectedRoute={false}
            component={ClientOrderList}
            exact={true}
          />
          <PrivateRoute
            path={Pages.InvestmentQuestionnaire + '/:clientId'}
            protectedRoute={false}
            component={InvestmentQuestionnaire}
            exact={true}
          />
          <PrivateRoute
            path={Pages.ImportDocuments + '/:clientId'}
            protectedRoute={false}
            component={ImportDocuments}
            exact={true}
          />
          <PrivateRoute
            path={Pages.ClientInstrumentOrderList + '/:clientId/:instrumentName'}
            protectedRoute={false}
            component={ClientOrderList}
            exact={true}
          />
          <PrivateRoute
            path={Pages.ClientDetailDocuments + '/:clientId/'}
            protectedRoute={true}
            distributorAllowed={true}
            component={ClientDetailDocuments}
            exact={true}
          />
          <PrivateRoute path={Pages.Documents} protectedRoute={true} component={Documents} exact={true} />
          <PrivateRoute path={Pages.OrderList} protectedRoute={true} component={OrderList} exact={true} />
          <PrivateRoute path={Pages.TraderDiary} protectedRoute={true} component={TraderDiary} exact={true} />
          <PrivateRoute
            path={Pages.MarketOverview}
            protectedRoute={false}
            distributorAllowed={true}
            component={MarketOverview}
            exact={true}
          />
          <PrivateRoute path={Pages.InstrumentList} protectedRoute={true} component={InstrumentList} exact={true} />
          <PrivateRoute
            path={Pages.Ops}
            protectedRoute={false}
            distributorAllowed={false}
            component={OpsRoot}
            exact={true}
          />
          <PrivateRoute
            path={Pages.DistributorMgmtFee}
            protectedRoute={false}
            distributorAllowed={true}
            component={DistributorMgmtFee}
            exact={true}
          />
          <Route path={Pages.AccessForbidden} component={AccessForbidden} exact={true} />
          <Route path={Pages.Login} component={LoginPage} exact={true} />
          <PrivateRoute path={Pages.Home} protectedRoute={true} distributorAllowed={true} component={ClientList} exact={true} />
        </>
      )}
      {isClientUser() && (
        <>
          <PrivateRoute
            path={Pages.ClientDetail + '/:clientId'}
            protectedRoute={false}
            component={ClientDetail}
            exact={true}
          />
          <PrivateRoute
            path={Pages.ClientDetail + '/:clientId/:portfolio'}
            protectedRoute={false}
            component={ClientDetail}
            exact={true}
          />
          <PrivateRoute
            path={Pages.InvestmentQuestionnaire + '/:clientId'}
            protectedRoute={false}
            component={InvestmentQuestionnaire}
            exact={true}
          />
          <PrivateRoute
            path={Pages.ImportDocuments + '/:clientId'}
            protectedRoute={false}
            component={ImportDocuments}
            exact={true}
          />
          <PrivateRoute
            path={Pages.MarketOverview}
            protectedRoute={false}
            component={MarketOverview}
            exact={true}
          />
          <PrivateRoute path={Pages.Home} protectedRoute={false} component={redirectToClientIQ} exact={true} />
          {/* HIDDEN: Pokyny page disabled for clients */}
          {/* <PrivateRoute path={Pages.ClientOrderList + '/:clientId'} protectedRoute={false} component={ClientOrderList} exact={true} /> */}
        </>
      )}
    </Switch>
  )
}
